/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import styles from './index.module.less';
import { milliFormat, phoneNumFormat } from '../../utils/tool';
import webview from '../../utils/webview';
import { report, submitOrder, getGoods, getAvailOrder, payOrder } from '../../services/api';
import { Route, Switch, useLocation } from 'react-router-dom';
import RechargeHistory from './components/history'

export default class Recharge extends Component {
    state = {
        cardList: [
            {
                id: 1,
                discount: 1,
                count: 10000
            }
        ],
        phoneTypeList: [
            {
                name: 'viettel',
                code: '45204',
                cover: require('../../assets/payment/viettel.jpg'),
                ussd: '*098#'
            }, {
                name: 'mobifone',
                code: '45201',
                cover: require('../../assets/payment/mobifone.jpg'),
                ussd: '*0#'
            }, {
                name: 'vinaphone',
                code: '45202',
                cover: require('../../assets/payment/vinaphone.jpg'),
                ussd: '*110#'
            }
        ],
        processOrderList: [],
        userInfo: '',
        simData: [],
        selectCard: {
            discount: 0.1,
            count: 10000
        },
        selectIndex: 0,
        selectNumIndex: 0,
        tipsInfo: "Chức năng đang được phát triển !",
        showTipsModal: false,
        showDialogModal: false,
        dialogTitle: '',
        dialogContent: '',
        dialogOnCancel: null,
        dialogOnConfirm: null,
        otherCount: 0,
        tipsLog: '',
        loadingInfo: '',
        showLogModal: false,
        showLoadingModal: false,
        userName: 'Đăng nhập',
        userAvator: require('../../assets/recharge/avatarDefault.png'),
        showSubmitContent: true,
        navTitleWords: 'Nạp tiền điện thoại',
        selectVendor: '',
        submitOrderInfo: '',
        dialogTopBtnText: '',
        dialogBottomBtnText: '',
        appVersion: '',
    }

    componentDidMount() {
        this.getUserInfo();
        this.getPhoneInfo();
        this.getProcessOrderList();
        window.addEventListener('popstate', (state) => {
            console.log(state);
            this.setState({
                showSubmitContent: true,
                navTitleWords: 'Nạp tiền điện thoại',
            });
        })
        this.showLoading();
    }

    componentWillUnmount() {
        window.removeEventListener('popstate');
    }

    sendFail = () => {
        this.setState({ showTipsModal: true, tipsInfo: 'Tạm thời chưa hỗ trợ !' }, () => {
            setTimeout(() => {
                this.setState({ showTipsModal: false, tipsInfo: '' })
            }, 1500)
        })
    }

    // 获取用户设备信息
    getPhoneInfo = () => {
        const { phoneTypeList } = this.state;
        this.setState({ showTipsModal: true, tipsInfo: 'Đang lấy số điện thoại ...' })
        // 获取用户手机信息
        webview.getPhoneInfo().then(res => {
            if (res && res.ret === 0) {
                const { params } = res;
                console.log(params);
                // this.showDialog('TestLog', JSON.stringify(res), null, () => {
                report(res);
                this.setState({
                    showTipsModal: false, tipsInfo: '',
                    appVersion: params.app_ver
                });

                if (params.code === 1001) { //权限未打开
                    this.showDialog('', 'Cần ủy quyền của bạn');
                } else if (params.code === 1003) {//安卓版本过低
                    this.showDialog('', 'Chức năng đang phát triển, hãy thử lại sau vài hôm');
                } else if (params.app_ver < "3.17.30") {//app版本低于3.17.30则提示不支持
                    this.showDialog('', 'Phiên bản APP hết hạn, cần phải nâng cấp');
                } else {
                    if (params.sim_data && params.sim_data.length > 0) {//获取sim卡信息
                        report(params);
                        let tempSimData = params.sim_data;
                        let targetSimArr = [];
                        tempSimData.map((item, index) => {
                            let targetSim = phoneTypeList.filter(_item => _item.code === item.operator_code);
                            if (targetSim.length < 1) {//兼容越南卡在中国的情况，operator_code会发生变化，name里面会包含运营商名例如：中国移动-Viettel
                                targetSim = phoneTypeList.filter(_item => {
                                    let carrierName = item.carrier_name.toLocaleLowerCase();
                                    return carrierName.indexOf(_item.name) !== -1;
                                });
                            }
                            if (targetSim.length > 0) {
                                item.vendor = targetSim[0].name;
                                targetSimArr.push(item);
                            }
                        });
                        if (targetSimArr.length < 1) {
                            this.showDialog('', 'Không nhận được Sim');
                        } else {
                            this.setState({
                                simData: targetSimArr,
                                selectVendor: targetSimArr[0].vendor.toUpperCase()
                            }, () => {
                                this.getGoodsList();
                            })
                        }
                    } else {
                        this.showDialog('', 'Không nhận được Sim');
                        report(res);
                    }
                }
                // });
            } else {
                console.log("获取手机信息失败");
                // 获取手机信息失败,提示不支持用户手机
                report(res);
                this.sendFail()
            }
        }).catch(e => {
            // 获取手机信息失败,提示不支持用户手机
            console.log("获取手机信息失败");
            report({ ...e, msg: 'not in app' });
            this.sendFail()
        })
    }

    getUserInfo = () => {
        webview.userInfo().then(res => {
            console.log(res);
            if (res && res.ret === 0) {
                const { params } = res;
                if (params.login_token && params.user) {
                    this.setState({
                        userInfo: params
                    });
                    this.getProcessOrderList();
                    if (params.user.avatar) {
                        this.setState({
                            userAvator: params.user.avatar
                        });
                    }
                    if (params.user.nickname) {
                        this.setState({
                            userName: params.user.nickname
                        });
                    } else {
                        this.setState({
                            userName: ""
                        });
                    }
                }
            }
        });
    }

    selectItem = (item, index) => {
        if (item) {
            this.setState({
                selectCard: item,
                selectIndex: index
            })
        }
    }

    selectCardInfo = (item, index) => {
        if (item) {
            this.showLoading();
            this.setState({
                selectNumIndex: index,
                selectVendor: item.vendor.toUpperCase()
            });
            this.getGoodsList(item.vendor);
        }
    }

    submitAmount = () => {
        const { simData, selectNumIndex, selectCard, userInfo, appVersion } = this.state;
        console.log(selectCard);
        if (this.checkLogin()) {//登录状态，并且卡能正常支付
            if (simData.length > 0) {
                this.setState({ showTipsModal: true, tipsInfo: 'Đang gửi đơn hàng' })
                //下单
                let data = {
                    "app_id": 1,
                    "user_id": userInfo.uid,
                    "device_id": "2",
                    "sim_id": simData[selectNumIndex].icc_id,
                    "phone": simData[selectNumIndex].phone_num,
                    "product_id": selectCard.id
                };
                let hearder = {
                    "app-id": 1,
                    "user-id": userInfo ? userInfo.uid : '',
                    "token": userInfo ? userInfo.login_token : '',
                };
                submitOrder(data, hearder).then(res => {
                    if (res && res.code === 0) {
                        this.setState({
                            showTipsModal: true,
                            tipsInfo: 'Gửi đơn hàng thành công',
                            submitOrderInfo: res.data
                        }, () => {
                            setTimeout(() => {
                                webview.openWebSocket().then(res => {//通知SDK建立长连接
                                    console.log('res of open websocket=' + JSON.stringify(res));
                                    if (res && res.ret === 0) {
                                        const { params } = res;
                                        if (params && params.code === 0) {
                                            const { submitOrderInfo } = this.state;
                                            this.setState({ showTipsModal: true, tipsInfo: 'MoMo Đang mở MOMO' });
                                            payOrder(
                                                {
                                                    'order_id': submitOrderInfo.id + ''
                                                }, {
                                                    "app-id": 1,
                                                    "user-id": userInfo ? userInfo.uid : '',
                                                    "token": userInfo ? userInfo.login_token : '',
                                                }).then(payRes => {
                                                    if (payRes && payRes.code === 0) {
                                                        if (appVersion > '3.17.32') {//版本兼容，3.17.33之前版本不支持设置UA
                                                            webview.getUserAgent().then(getUaRes => {
                                                                let cacheAgent = sessionStorage.getItem('user_agent');
                                                                if (getUaRes && getUaRes.ret == 0) {
                                                                    if (!(cacheAgent && cacheAgent !== 'undefined')) {
                                                                        getUaRes.params && sessionStorage.setItem('user_agent', getUaRes.params.user_agent);
                                                                    }
                                                                }
                                                                this.showDialog('', 'PHường thức thanh toán', () => {
                                                                    console.log('cacheAgent=' + cacheAgent);
                                                                    if (cacheAgent && cacheAgent !== 'undefined') {
                                                                        webview.changeUserAgent({
                                                                            params: {
                                                                                'user_agent': cacheAgent
                                                                            }
                                                                        }).then(response => {
                                                                            window.location.href = payRes.pay_url;
                                                                        });
                                                                    } else {
                                                                        window.location.href = payRes.pay_url;
                                                                    }
                                                                }, () => {
                                                                    webview.changeUserAgent({
                                                                        params: {
                                                                            'user_agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.107 Safari/537.36'
                                                                        }
                                                                    }).then(response => {
                                                                        window.location.href = payRes.pay_url;
                                                                    });
                                                                }, 'Thanh toán bằng MoMo trên điện thoại', 'Scan QR Code MoMo');
                                                            });
                                                        } else {
                                                            window.location.href = payRes.pay_url;
                                                        }
                                                    } else {
                                                        this.setState({ showTipsModal: true, tipsInfo: 'Lấy trang thanh toán thất bại, xin thử lại' });
                                                        setTimeout(() => {
                                                            this.setState({ showTipsModal: false, tipsInfo: '' });
                                                        }, 2 * 1000);
                                                    }
                                                });
                                        } else {
                                            this.setState({ showTipsModal: true, tipsInfo: 'Đăng đơn hàng thất bại, xin thử lại' });
                                            setTimeout(() => {
                                                this.setState({ showTipsModal: false, tipsInfo: '' });
                                            }, 2 * 1000);
                                        }
                                    } else {
                                        this.setState({ showTipsModal: true, tipsInfo: 'Đăng đơn hàng thất bại, xin thử lại' });
                                        setTimeout(() => {
                                            this.setState({ showTipsModal: false, tipsInfo: '' });
                                        }, 2 * 1000);
                                    }
                                });
                            }, 1500);
                        });
                    } else {
                        this.setState({ showTipsModal: true, tipsInfo: 'Đăng đơn hàng thất bại, xin thử lại' });
                        setTimeout(() => {
                            this.setState({ showTipsModal: false, tipsInfo: '' });
                        }, 2 * 1000);
                    }
                    console.log(res);
                });
            } else {
                this.showDialog('', 'Không nhận được Sim');
            }
        }
    }

    getGoodsList = (vendor) => {
        const { selectVendor, userInfo } = this.state;
        const currentVendor = vendor || selectVendor;
        getGoods({
            "app_id": 1,
            "vendor": currentVendor
        }, {
                "app-id": 1,
                "user-id": userInfo ? userInfo.uid : '',
                "token": userInfo ? userInfo.login_token : '',
            }).then(res => {
                if (res && res.code === 0) {
                    this.hideLoading();
                    if (res.data.length > 0) {
                        let goodsList = res.data.map(item => {
                            return {
                                count: item.topup_amount,
                                discount: (1 - item.price_amount / item.topup_amount).toFixed(2),
                                id: item.id
                            }
                        });
                        this.setState({
                            cardList: goodsList,
                            selectCard: goodsList[0]
                        });
                    } else {
                        this.showDialog('', 'Hệ thống lỗi, hãy thử lại sau');
                    }

                } else {
                    this.showDialog('', 'Hệ thống lỗi, hãy thử lại sau');
                }
            });
    }

    getProcessOrderList = () => {
        const { userInfo } = this.state;
        getAvailOrder({
            "app_id": 1,
            "user_id": userInfo.uid,
        }, {
                "app-id": 1,
                "user-id": userInfo ? userInfo.uid : '',
                "token": userInfo ? userInfo.login_token : '',
            }).then(res => {
                if (res && res.code === 0) {
                    this.setState({
                        processOrderList: res.data
                    });
                }
            });
    }

    checkLogin = () => {
        const { userInfo } = this.state;
        if (!userInfo.uid || !userInfo.login_token) {//uid为空时，拉起登录界面
            this.showDialog('', 'Bạn chưa đăng nhập, xin đăng nhập', () => { }, () => {
                webview.login().then(res => {//登录成功
                    if (res === 1) {
                        this.getUserInfo();
                    }
                });
            });
            return false;
        } else {
            return true;
        }
    }

    onHistoryBtn = () => {
        const { userInfo } = this.state;
        if (this.checkLogin()) {
            this.setState({
                navTitleWords: 'Đơn hàng của tôi',
                showSubmitContent: false
            });
            this.props.history.push('/recharge/history', { userInfo: userInfo });//需要响应安卓返回按键，使用子路由实现
        }
    }

    showLoading = (info) => {
        this.setState({
            loadingInfo: info,
            showLoadingModal: true
        });
    }

    hideLoading = () => {
        this.setState({
            showLoadingModal: false,
            loadingInfo: ''
        });
    }

    /* 
    * 显示对话框
    * 当cancelCallback和confirmCallback都为空时，对话框将无法退出
     */
    showDialog = (title, content, cancelCallback, confirmCallback, leftBtnText, rightBtnText) => {
        this.hideLoading();
        const hideDialog = () => {
            this.setState({
                dialogTitle: '',
                dialogContent: '',
                showDialogModal: false,
                dialogOnCancel: null,
                dialogOnConfirm: null
            });
        }
        this.setState({
            dialogTitle: title,
            dialogContent: content,
            showDialogModal: true,
            dialogTopBtnText: leftBtnText ? leftBtnText : '',
            dialogBottomBtnText: rightBtnText ? rightBtnText : '',
        });
        if (Object.prototype.toString.call(cancelCallback) === '[object Function]') {
            this.setState({
                dialogOnCancel: () => {
                    cancelCallback.call(this);
                    hideDialog();
                }
            });
        }

        if (Object.prototype.toString.call(confirmCallback) === '[object Function]') {
            this.setState({
                dialogOnConfirm: () => {
                    confirmCallback.call(this);
                    hideDialog();
                }
            });
        }
    }

    render() {
        const { cardList, selectCard, simData, phoneTypeList, selectIndex, selectNumIndex, tipsInfo, showTipsModal, tipsLog, showLogModal,
            userName, userAvator, processOrderList, showDialogModal, dialogTitle, dialogContent, dialogOnCancel, dialogOnConfirm, showSubmitContent,
            navTitleWords, loadingInfo, showLoadingModal, dialogTopBtnText, dialogBottomBtnText } = this.state;

        const renderCardList = () => {
            return cardList.map((item, index) => {
                return <div className={`${styles.cardItem} ${selectIndex === index ? styles.showSelected : null}`} key={index}
                    onClick={this.selectItem.bind(null, item, index)}>
                    <div className={styles.cardNum}>{milliFormat(item.count)}đ</div>
                    <div className={styles.cardDiscount}>Giảm {item.discount * 100}%</div>
                </div>
            })
        }
        const renderPhoneCardList = () => {
            return simData.map((item, index) => {
                let targetSim = phoneTypeList.filter(_item => _item.code === item.operator_code);
                if (targetSim.length < 1) {//越南的卡在深圳operator_code会变，但是name不会变。重新获取
                    targetSim = phoneTypeList.filter(_item => _item.name === item.vendor);
                }
                if (targetSim.length < 1) {//不是越南的卡
                    return <></>
                } else {
                    return <div key={index} onClick={this.selectCardInfo.bind(null, item, index)}>
                        <div className={styles.cardInfoItem}>
                            <div className={styles.cardCover}>
                                {targetSim && targetSim.length > 0 ? <img src={targetSim[0].cover} alt={targetSim.name} /> : null}
                            </div>
                            <div className={`${styles.cardNum} ${selectNumIndex === index ? styles.cardNumSelected : styles.cardNumNotSelected}`}>{phoneNumFormat(item.phone_num)}</div>
                        </div>
                        {index < simData.length - 1 ? <div className={styles.cardInfoHLine}></div> : null}
                    </div>
                }
            });
        }
        const renderOrderList = () => {
            return processOrderList.map((item, index) => {
                return <div className={styles.historyItem} key={index}>
                    <div className={styles.historyOperator}>{item.vendor}</div>
                    <div className={styles.historyNum}>{phoneNumFormat(item.topup_phone)}</div>
                    <div className={styles.historyAmount}>{`${milliFormat(item.topup_amount)}đ`}</div>
                </div>
            });
        }
        return <div>
            <div className={styles.container}>
                <div className={styles.navWrapper}>
                    <div className={styles.navLogin} onClick={this.checkLogin}>
                        <div>
                            <img src={userAvator} />
                        </div>
                        <span>{userName}</span>
                    </div>
                    {/* <span className={styles.navTitle}>{navTitleWords}</span> */}
                    {showSubmitContent ? <div className={styles.historyBtn} onClick={this.onHistoryBtn}>
                        <img src={require('../../assets/recharge/historyBtn.png')} />
                    </div> : null}
                </div>
                <div className={styles.navHLine}></div>
                {showSubmitContent ? <>
                    <div className={styles.optionWrapper}>
                        <div className={styles.cardInfo}>
                            {renderPhoneCardList()}
                        </div>
                        <div className={styles.cardWrapper}>
                            {renderCardList()}
                        </div>
                        <div className={styles.cardDesc}>Dự kiến chờ 10 phút</div>
                    </div>
                    <div className={styles.historyHLine}></div>
                    <div className={styles.historyOrder}>
                        {processOrderList.length > 0 ? <div className={styles.historyTitle}>Đang xử lý</div> : null}
                        <div className={styles.historyWrapper}>
                            {renderOrderList()}
                        </div>
                    </div>
                    <div className={styles.settlementPane}>
                        <div className={styles.countInfo}>
                            <div className={styles.countLine}>
                                <div className={styles.countTitle}>Cần thanh toán :&nbsp;</div>
                                <div className={styles.amount}>{selectCard ? `${milliFormat(selectCard.count - (selectCard.count * selectCard.discount))}đ` : '0đ'}</div>
                            </div>
                            <div className={styles.discountLine}>
                                <div className={styles.discountTitle}>Số tiền được giảm&nbsp;</div>
                                <div className={styles.disAmount}>{selectCard ? `${milliFormat(selectCard.count * selectCard.discount)}đ` : '0đ'}</div>
                            </div>
                        </div>
                        <div className={styles.sendBtn} onClick={this.submitAmount}>Nạp ngay</div>
                    </div>
                </> : null}
                <Switch>
                    <Route path="/recharge/history" component={RechargeHistory}></Route>
                </Switch>
            </div>
            {showTipsModal ? <div className={styles.tipsModal}>
                <div className={styles.tips}>{tipsInfo}</div>
            </div> : null}
            {showDialogModal ? <div className={styles.dialogModal}>
                <div className={styles.dialogWrapper}>
                    <div className={styles.dialogTitle}>{dialogTitle}</div>
                    {dialogContent ? <div className={styles.dialogContent}>{dialogContent}</div> : null}
                    {!dialogTopBtnText ? <div className={styles.dialogButtons}>
                        {dialogOnCancel ? <button className={styles.dialogCancelBtn} onClick={dialogOnCancel}>Hủy</button> : null}
                        {dialogOnConfirm ? <button className={styles.dialogConfirmBtn} onClick={dialogOnConfirm}>Xác nhận</button> : null}
                    </div> :
                        <div className={styles.dialogBigButtons}>
                            {dialogOnCancel ? <button className={styles.bigBtnItem} onClick={dialogOnCancel}>{dialogTopBtnText}</button> : null}
                            {dialogOnConfirm ? <button className={styles.bigBtnItem} onClick={dialogOnConfirm}>{dialogBottomBtnText}</button> : null}
                        </div>}
                </div>
            </div> : null}
            {showLoadingModal ? <div className={styles.loadingModal}>
                <div className={styles.loading}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                {loadingInfo ? <div className={styles.loadingTxt}>{loadingInfo}</div> : null}
            </div> : null}
        </div >
    }
}